export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-background-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <span className="font-heading text-2xl text-background-50">皮皮漫画</span>
            <p className="mt-4 text-sm text-background-400 leading-relaxed">
              皮皮漫画网专注日韩与国漫精品推荐，韩漫排行榜实时更新，日漫系列全集下拉畅读，国漫大图高清全彩。资源全面更新快，满足日韩控和国漫迷的追更需求。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">快速导航</h3>
            <div className="flex flex-col gap-2.5">
              <a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">更新快讯</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门话题</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">排行榜</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">漫画分类</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">漫画品类</h3>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-background-400">韩漫推荐</span>
              <span className="text-sm text-background-400">日漫系列</span>
              <span className="text-sm text-background-400">国漫精选</span>
              <span className="text-sm text-background-400">热血冒险</span>
              <span className="text-sm text-background-400">恋爱都市</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500">更多精彩站点即将加入</p>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 皮皮漫画网 - 日韩与国漫精品推荐平台
          </p>
          <div className="flex items-center gap-6">
            <a href="#contact" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
            <a href="#about" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</a>
            <a href="#faq" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}